import { FulfillmentCutoffScheduleParser } from "@redotech/redo-model/checkouts/fulfillment-cutoff";
import * as z from "zod/v4";

export const updateFulfillmentCutoffSchedule = {
  name: "updateFulfillmentCutoffSchedule" as const,
  input: z.object({
    schedule: z.union([FulfillmentCutoffScheduleParser, z.null()]),
  }),
  output: z.null(),
};
